import { VisibilityScopeValue } from "../../../components/ui/VisibilityScope";
export type UprightType = {
  id: string;
  code: string;
  name: string;
  nameIt: string | null;
  nameDe: string | null;
  nameEs: string | null;
  nameFr: string | null;
  image?: string;
  order: number;
  visibility: VisibilityScopeValue;
};

export type InsertUprightTypeBody = Omit<UprightType, "id">;

export type UpdateUprightTypeRemoveImageBody = Omit<UprightType, "id" | "image"> & {
  removeImage?: boolean;
};

export type UpdateUprightTypeNewImageBody = Omit<UprightType, "id">;

export const BORDER_RECLINABLE_UPRIGHT_TYPE_CODE = "RECLINING";

export const isBorderUprightReclinable = (uprightTypeCode: string | null): boolean =>
  uprightTypeCode === BORDER_RECLINABLE_UPRIGHT_TYPE_CODE;
